import React, {Component} from "react";
import {inject, observer} from 'mobx-react';
import {Modal} from "antd";
import * as mobx from 'mobx';
import {stopEvent, getInputKeys} from "../../util/TreeUtil";
import SearchFavourite from "../../util/SearchFavourite";

@observer
export default class FavDirBar extends Component {
    /**
     * 新建目录事件
     * @param evt
     */
    addTreeNode = () => {
        let {favouriteDirStore} = this.props;
        favouriteDirStore.curTree.tree.addRootNode();
    }

    /**
     * 全部目录，鼠标移入、移出、点击
     */
    handleRootNodeOver = (evt) => {
        let {favouriteDirStore} = this.props;
        favouriteDirStore.setRootOver(true);
    }

    handleRootNodeOut = (evt) => {
        let {favouriteDirStore} = this.props;
        favouriteDirStore.setRootOver(false);
    }

    handleRootNodeClick = (evt) => {
        let {favouriteDirStore, sysFavouriteStore} = this.props;
        favouriteDirStore.setRootClick(true);
        
        /**
         * 选中树根节点后，刷新收藏的列表
         */
        let isinit = true;
        let isreload = false;
        SearchFavourite.setConditions({dirId: "0"});
        let searchFavourite = new SearchFavourite(sysFavouriteStore);
        searchFavourite.load({isinit, isreload});
    }

    componentDidMount() {
        let that = this;
        jQuery(".fav-left-bar-btn").unbind("click").bind("click", function (e) {
            stopEvent();
            that.addTreeNode(e);
        });
    }

    render() {
        let {favouriteDirStore, myFavouriteStore} = this.props;
        let {isover, selectedKey} = favouriteDirStore;
        let {allDirName, addDirTitle} = myFavouriteStore;
        let cls = "fav-left-bar";
        if (isover) {
            cls += " fav-left-bar-over";
        }
        if (selectedKey == "0") {
            cls += " fav-left-bar-click";
        }

        return (
            <div className={cls} onClick={this.handleRootNodeClick} onMouseOver={this.handleRootNodeOver}
                 onMouseOut={this.handleRootNodeOut}>
                <div className="fav-left-bar-title fav-bar-common">
                    <span className="fav-left-bar-title-icon"></span>
                    <span>{allDirName}</span>
                </div>
                <div className="fav-left-bar-btn fav-bar-common"  title={addDirTitle}></div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ../src4js/pc4mobx/favourite/components/dir/FavDirBar.js